import { fetchStoriesHandler } from '~/handlers/fetch-stories.handler';
import { useStoriesStore } from '~/stores/apostatudo/stories';

export const useStories = () => {
  const { setStories } = useStoriesStore();

  async function loadStories() {
    const { stories } = await fetchStoriesHandler();

    setStories(stories);
  }

  return {
    loadStories,
  };
};
